module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tags_filter":"Tags filter","select_tag":"Select tag","add_tag":"Add","None":"None"},"fr":{"tags_filter":"Filtre de groupes","select_tag":"Sélectionnez un groupe","add_tag":"Ajouter","None":"Aucun"},"de":{"tags_filter":"Gruppenfilter","select_tag":"Wählen Sie eine Gruppe aus","add_tag":"Hinzufügen","None":"Keiner"}}')
  delete Component.options._Ctor
}
